import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { HERO_SLIDES } from '../data/heroSlides';

const INTERVAL_MS = 5200;
const CROSSFADE_S = 1.1;
const EASE_SMOOTH = [0.22, 1, 0.36, 1];

export default function HeroImageSlider() {
  const reduceMotion = useReducedMotion();
  const [index, setIndex] = useState(0);
  const publicUrl = process.env.PUBLIC_URL || '';
  const slide = HERO_SLIDES[index];

  useEffect(() => {
    if (reduceMotion) return undefined;
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % HERO_SLIDES.length);
    }, INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [reduceMotion]);

  useEffect(() => {
    const next = HERO_SLIDES[(index + 1) % HERO_SLIDES.length];
    const img = new Image();
    img.src = `${publicUrl}/${next.path}`;
  }, [index, publicUrl]);

  return (
    <div className="hero-image-slider" aria-live="polite" aria-label="Hero image gallery">
      <AnimatePresence initial={false} mode="sync">
        <motion.div
          key={slide.path}
          className="hero-image-slider__slide"
          initial={reduceMotion ? { opacity: 0 } : { opacity: 0, scale: 1.03 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={reduceMotion ? { opacity: 0 } : { opacity: 0, scale: 1.02 }}
          transition={{ duration: reduceMotion ? 0.2 : CROSSFADE_S, ease: EASE_SMOOTH }}
        >
          <motion.div
            className="hero-image-slider__kenburns"
            initial={reduceMotion ? false : { scale: 1 }}
            animate={reduceMotion ? undefined : { scale: 1.08 }}
            transition={
              reduceMotion
                ? undefined
                : { duration: INTERVAL_MS / 1000, ease: 'linear' }
            }
          >
            <img
              src={`${publicUrl}/${slide.path}`}
              alt={slide.title}
              loading={index === 0 ? 'eager' : 'lazy'}
              decoding="async"
            />
          </motion.div>
        </motion.div>
      </AnimatePresence>

      {!reduceMotion && (
        <motion.div
          className="hero-image-slider__progress"
          key={`progress-${slide.path}`}
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: INTERVAL_MS / 1000, ease: 'linear' }}
          aria-hidden="true"
        />
      )}
    </div>
  );
}
